import JsEvent from '@rotomeca/event';
import { Nullable } from '@rotomeca/utils';
import { HTMLBnumIcon } from 'components/atoms/icon/bnum-icon';
import { ValueOf } from 'core/utils/types';

export const ButtonVariation = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  DANGER: 'danger',
} as const;

export const IconPosition = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const HideTextOnLayoutSize = {
  SMALL: 'small',
  TOUCH: 'touch',
} as const;

/**
 * Type représentant les variations possibles du bouton.
 */
export type ButtonVariation = ValueOf<typeof ButtonVariation>;

/**
 * Position possible de l'icône dans le bouton.
 */
export type IconPosition = ValueOf<typeof IconPosition>;
/**
 * Taille de layout sur laquelle le texte doit être caché.
 */
export type HideTextOnLayoutSize = ValueOf<typeof HideTextOnLayoutSize>;

export type IconChangedEvent = JsEvent<
  (newIcon: string, oldIcon: string) => void
>;

export type LoadingStateChangedEvent = JsEvent<(state: boolean) => void>;

export type IconPropType = 'margin' | 'pos';

export type IconPropChangedEvent = JsEvent<
  (type: IconPropType, newValue: string) => void
>;

export type VariationChangedEvent = JsEvent<
  (newVariation: ButtonVariation, oldVariation: ButtonVariation) => void
>;

export type LinkedClickEvent = JsEvent<(link: string) => void>;

export type BnumButtonUi = {
  wrapper: HTMLDivElement;
  icon: HTMLBnumIcon;
};

export type BnumButtonCreateOptions = {
  text?: string;
  icon?: string | null;
  iconPos?: IconPosition;
  iconMargin?: string | null | 0;
  variation?: ButtonVariation | null;
  rounded?: boolean;
  loading?: boolean;
  hideOn?: Nullable<HideTextOnLayoutSize>;
};
